const INSPIRATION_FEED_PATH = '/inspiration-feed';

/**
 * Build an /inspiration-feed href pre-filtered to a single facet value. The
 * param names + value ids must match the URL contract in InspirationFeed.
 */
export const buildInspirationFeedHref = (
  param: 'roles' | 'stages' | 'tactics' | 'channels' | 'execution',
  value: string
) => `${INSPIRATION_FEED_PATH}?${param}=${encodeURIComponent(value)}`;

// ─── Typography config ──────────────────────────────────────────────────────
// Adjust these to control text sizes across the framework blocks.
export const TEXT = {
  // Card labels (e.g. "Brand building", "Strategy + insights")
  cardLabel: 'text-sm font-black uppercase tracking-[0.12em]',
  // Card headline / bold statement
  cardHeadline: 'text-lg font-black',
  // Card body / description text
  cardBody: 'mt-1.5 text-base leading-relaxed',
  // Journey stage label (KNOWN, CONSIDERED, etc.)
  stageLabel: 'text-xs font-black uppercase tracking-[0.1em]',
  // Journey stage outcome (Get noticed, Give them a reason, etc.)
  stageOutcome: 'mt-2 text-xl font-black leading-tight',
  // Journey stage description
  stageDescription: 'mt-2 text-base leading-relaxed',
  // Footnote / helper text
  footnote: 'text-base leading-7',
  // Execution service card title
  servicePill: 'text-base font-black',
  // Section sub-label (ACTIVITIES + EXECUTION)
  sectionLabel: 'text-sm font-black uppercase tracking-[0.12em]',
  // Section sub-description
  sectionDescription: 'text-base leading-7',
} as const;
